(function (angular) {
    angular.module('bizPartEngage').controller('modules.masterrun', masterrunController);

    masterrunController.$inject = ["$filter", "bizUser"];

    function masterrunController($filter, bizUser) {
        var vm = this;
        vm.MasterRunUrl = undefined;

        function Init() {
            if(isMobile.any()) {
                vm.MasterRunUrl = $filter('siteroot')("MasterRunMobile/index.html?session=" + getBizPartAuthToken());
            }
            else {
                vm.MasterRunUrl = $filter('siteroot')("MasterRun/index.html?session=" + getBizPartAuthToken());
            }
        }

        this.$onInit = Init;
    }
})(window.angular);
